var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M39.148 4.972 15.969 28.151a2.92 2.92 0 0 1-4.122 0L.853 17.156a2.915 2.915 0 0 1 4.122-4.122l8.334 8.335a.85.85 0 0 0 1.199 0L35.026.85a2.915 2.915 0 0 1 4.122 4.122"
  })));
};
export default SvgCheck;